/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DistritoProvinciaIdProvinceGet$Params {
  idProvince: string;
}

export function distritoProvinciaIdProvinceGet(http: HttpClient, rootUrl: string, params: DistritoProvinciaIdProvinceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, distritoProvinciaIdProvinceGet.PATH, 'get');
  if (params) {
    rb.path('idProvince', params.idProvince, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

distritoProvinciaIdProvinceGet.PATH = '/distrito/provincia/{idProvince}';
